import { ICON_PATHS, type IconName } from "./iconPaths";
import { cx } from "../lib/cx";

export type { IconName };

export function Icon({ name, size, className }: { name: IconName; size?: "sm" | "lg"; className?: string }) {
  return (
    <svg
      className={cx("icon", size === "sm" && "icon-sm", size === "lg" && "icon-lg", className)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: ICON_PATHS[name] }}
    />
  );
}
